import * as sortingRules from '~/utils/prepareComparisonDocs/sortingRules';
const prepareClassificationMap = (anchorDoc, comparatorDoc, selectedCategories, selectedDescriptors) => {
    var _a, _b;
    const classificationMap = new Map();
    for (const [name, classifications] of anchorDoc.classificationMap) {
        classifications.forEach(tabClauses => {
            classificationMap.set(name, {
                anchorClauses: tabClauses.classifications,
                comparatorClauses: [],
            });
        });
    }
    for (const [name, classifications] of comparatorDoc.classificationMap) {
        classifications.forEach(tabClauses => {
            const existingClassification = classificationMap.get(name);
            if (existingClassification) {
                existingClassification.comparatorClauses =
                    [...existingClassification.comparatorClauses, ...tabClauses.classifications];
            }
            else {
                classificationMap.set(name, {
                    anchorClauses: [],
                    comparatorClauses: tabClauses.classifications,
                });
            }
        });
    }
    const finalClassificationMap = new Map();
    const orderedClassifierKeys = sortTagsByRules(anchorDoc.classificationMap, comparatorDoc.classificationMap);
    for (const classifier of orderedClassifierKeys) {
        finalClassificationMap.set(classifier, classificationMap.get(classifier));
    }
    const hasSelectedCategories = selectedCategories.length > 0;
    const hasSelectedDescriptors = selectedDescriptors.length > 0;
    if (hasSelectedCategories) {
        for (const [name, classification] of finalClassificationMap) {
            if (!selectedCategories.includes((_a = classification.anchorClauses[0]) === null || _a === void 0 ? void 0 : _a.category) &&
                !classification.comparatorClauses.some(clause => selectedCategories.includes(clause.category))) {
                finalClassificationMap.delete(name);
            }
        }
    }
    if (hasSelectedDescriptors) {
        for (const [name, classification] of finalClassificationMap) {
            if (!selectedDescriptors.includes((_b = classification.anchorClauses[0]) === null || _b === void 0 ? void 0 : _b.descriptor) &&
                !classification.comparatorClauses.some(clause => selectedDescriptors.includes(clause.descriptor))) {
                finalClassificationMap.delete(name);
            }
        }
    }
    return finalClassificationMap;
};
const sortTagsByRules = (anchorTags, extraTags) => {
    let orderedClassifierKeys = [];
    orderedClassifierKeys = sortingRules.sortAnchorTagsByAnchorDocOrder(orderedClassifierKeys, anchorTags);
    orderedClassifierKeys = sortingRules.sortExtraTagsGroupedByCategory(orderedClassifierKeys, extraTags);
    return orderedClassifierKeys;
};
export default prepareClassificationMap;
